import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import { IconEdit, IconFilter, IconTrash } from "@tabler/icons-react";
import { deleteLeaves, getCategorys, getLeaves, getLeaveTypes, getProfitCenter, insertLeaves, } from "../../services/dataService";
import Loading from "../../components/common/Loading";
import toast from "react-hot-toast";
import Select from "react-select";
import FilterComponent from "../pages/FilterComponent";
import { getSecureItem } from "../../services/SecureStorage";


export default function Leave() {
  const UID = getSecureItem("userId");
  const [addLeaveModal, setAddLeaveModal] = useState(false);
  const [editLeaveModal, setEditLeaveModal] = useState(false);
  const [leaves, setLeaves] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [category, setCategory] = useState([]);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [typesofLeaves, setTypesofLeaves] = useState([]);
  const [LeaveIdToDelete, setLeaveIdToDelete] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const [leaveData, setLeaveData] = useState({
    Id: "",
    Name: "",
    NoOfLeaves: "",
    TypeId: "",
    Year: "",
    CategoryId: "",
    NoOfWorkingdays: "",
    AllowableLeave: "",
    UserId: UID,
    SpecialLeave: "",
    isChecked: Boolean(isChecked),
    percentage: null,
    NoOfextraleave: "1",
  });
  const clearData = () => {
    setLeaveData({
      Id: "",
      Name: "",
      NoOfLeaves: "",
      TypeId: "",
      Year: "",
      CategoryId: "",
      NoOfWorkingdays: "",
      AllowableLeave: "",
      UserId: UID,
      SpecialLeave: "",
      isChecked: Boolean(isChecked),
      percentage: null,
      NoOfextraleave: "1",
    });
    setIsChecked(false);
  };
  const clearDataedit = () => {
    setLeaveData((ref)=>({
    ...ref,
      Name: "",
      NoOfLeaves: "",
      TypeId: "",
      Year: "",
      CategoryId: "",
      NoOfWorkingdays: "",
      AllowableLeave: "",
      UserId: UID,
      SpecialLeave: "",
      isChecked: Boolean(isChecked),
      percentage: null,
      NoOfextraleave: "1",
    }));
    setIsChecked(false);
  };

  console.log("leaveData", leaveData.isChecked);

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;
    setIsChecked(checked);
    // Update leaveData with the isChecked value
    setLeaveData((prev) => ({
      ...prev,
      isChecked: checked,
    }));
  };


  const openAddLeaveModal = () => {
    setLeaveData({
      Id: "",
      Name: "",
      NoOfLeaves: "",
      TypeId: "",
      Year: "",
      CategoryId: "",
      NoOfWorkingdays: "",
      UserId: UID,
      SpecialLeave: "",
      isChecked: Boolean(isChecked),
      percentage: null,
      NoOfextraleave: "1",
    });
    setIsChecked(false);
    setAddLeaveModal(!addLeaveModal);
  };

  const fetchLeaves = async () => {
    try {
      const data = await getLeaves(UID);
      console.log(data.data.data, "Fetched data");
      setLeaves(data.data.data);
      setIsFilterVisible(false)
    } catch (error) {
      console.error("Error fetching leaves", error);
    }
  };

  const fetchLeaveTypes = async () => {
    try {
      const data = await getLeaveTypes(UID);
      console.log(data.data.data, "Fetched data");
      // Filter out the "Absent" leave type
      const filteredLeaveTypes = data.data.data.filter(leaveType => leaveType.Name !="Absent");
      setTypesofLeaves(filteredLeaveTypes);
      console.log(filteredLeaveTypes, "Leave types without Absent");
    } catch (error) {
      console.error("Error fetching leaveTypes", error);
    }
  };

  
  // sdgfds
  const openEditLeaveModal = (data) => {
    console.log("da===========================>ta", data);
    console.log(leaves, "leave");
    const LeaveName = typesofLeaves.find((item) => item.Id === data?.TypeId);
    console.log("data?.isChecked", data?.isChecked);
    setEditLeaveModal(!editLeaveModal);
    console.log("leavedataaa", data);

    setLeaveData({
      ...data,
      LeaveName: LeaveName?.Name,
      isChecked: data?.isChecked ==='true'?true:false,
      UserId: UID || "",
    });
    setIsChecked( data?.isChecked ==='true'?true:false)
  };
  
useEffect(() => {
 console.log("ischecked",isChecked);
}, [isChecked])


  useEffect(() => {
    fetchLeaves();
    fetchLeaveTypes();
  }, []);

  useEffect(() => {
    if (leaves && leaves.length > 0) {
      const updatedData = leaves.map((item, index) => ({
        Slno: index + 1,
        Id: item.Id || "",
        Name: item.Name || "",
        NoOfLeaves: item.NoOfLeaves || "",
        NoOfWorkingdays: item.NoOfWorkingdays || "",
        AllowableLeave: item.AllowableLeave || "",
        SpecialLeave: item.SpecialLeave || "",
        NoOfextraleave: item.NoOfextraleave || "",
        Year: item.Year || "",
        CategoryId: item.CategoryId || "",
        TypeId: item.TypeId || "",
        isChecked: item.isChecked || "",
        UserId: UID || "",
        LeaveName:
          typesofLeaves?.find((el) => el.Id === item.TypeId)?.Name || "",
        percentage: item.percentage || "",
      }));
      setDataFilter(updatedData);
    } else { setDataFilter([]) }
  }, [leaves]);

  // const handleChange = (e) => {
  //   console.log(leaveData, "leaveData");
  //   const { name, value } = e.target;
  //   setLeaveData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };
  const handleChange = (e) => {
    if (Array.isArray(e)) {
      const selectedValues = e.map((option) => option.value); // Extract values
      setLeaveData((prev) => ({
        ...prev,
        CategoryId: selectedValues,
      }));
      return;
    }

    const { name, value, options } = e.target;

    if (e.target.multiple) {
      const selectedValues = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);

      setLeaveData((prev) => ({
        ...prev,
        [name]: selectedValues,
      }));
    } else {
      setLeaveData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    console.log(leaveData, "leaveData");
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);

  //   try {
  //     const requests = leaveData.CategoryId.map((CategoryId) => {
  //       const updatedLeaveData = {
  //         ...leaveData,
  //         UserId: UID,
  //         CategoryId: CategoryId,
  //       };
  //       return insertLeaves(updatedLeaveData);
  //     });

  //     const response = await Promise.all(requests);

  //     response.forEach((res) => {
  //       if (res.data.data.StatusCode === 200) {
  //         toast.success(res.data.data.message);
  //       }
  //     });

  //     fetchLeaves();
  //     openAddLeaveModal();
  //   } catch (error) {
  //     const errorMessage =
  //       error.response?.data?.error ||
  //       error.message ||
  //       "An unexpected error occurred.";

  //     if (errorMessage.includes("Duplicate")) {
  //       toast.error(errorMessage);
  //     } else {
  //       toast.error("Error occurred while adding Leave.");
  //     }
  //     console.error("Error adding Leave:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // edit

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log(leaveData);
    

    try {
      const requests = leaveData.CategoryId.map((CategoryId) => {
        const updatedLeaveData = {
          ...leaveData,
          UserId: UID,
          CategoryId: CategoryId,
        };
        return insertLeaves(updatedLeaveData);
      });

      const responses = await Promise.all(requests);

      // Flag to track if all operations succeeded
      let allSuccess = true;
      let successMessage = "Leave added successfully."; // Default message

      // Check each response and determine if all operations succeeded
      responses.forEach((res) => {
        if (res.data.data.StatusCode !== 200) {
          allSuccess = false; // If any response fails, set to false
        }
      });

      // Show a single success notification if all operations succeeded
      if (allSuccess) {
        toast.success(successMessage);
      } else {
        toast.error("Some leaves could not be added.");
      }

      // Refresh the leave list and open the modal
      fetchLeaves();
      openAddLeaveModal();
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";

      if (errorMessage.includes("Duplicate")) {
        toast.error(errorMessage);
      } else {
        toast.error("Error occurred while adding Leave.");
      }
      console.error("Error adding Leave:", error);
    } finally {
      setLoading(false);
    }
  };



  const handleEdit = async (e) => {
    e.preventDefault()
    setLoading(true);
    try {
      const response = await insertLeaves(leaveData);
      if (response.data.data.StatusCode === 200) {
        toast.success(response.data.data.message);
        fetchLeaves();
        console.log('200');
        
        openEditLeaveModal();
      }
    } catch (error) {
      console.log('500',error);

      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";
      if (errorMessage.includes("Duplicate")) {
        toast.error(errorMessage);
      } else {
        toast.error("Error occurred while Editing Leave.");
      }
    }
    finally {
      setLoading(false);
    }
  };
  // profit center fetch
  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const response = await getCategorys(UID);
        setCategory(response.data.data);
        console.log(category, "pro");
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };

    fetchCategory();
  }, []);


  // useEffect(() => {
  //   const fetchLeaveType = async () => {
  //     try {
  //       const response = await getLeaveTypes(UID);
  //       setTypesofLeaves(response.data.data);
  //       console.log(typesofLeaves, "naame");
  //       console.log(category, "pro");
  //     } catch (error) {
  //       console.error("Error fetching profit centers:", error);
  //     }
  //   };

  //   fetchLeaveType();
  // }, []);


  useEffect(()=>{
console.log("leavedata shahna",leaveData);

  },[leaveData])

  const openModal = (LeaveId) => {
    setLeaveIdToDelete(LeaveId);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setLeaveIdToDelete(null);
  };

  const confirmDelete = () => {
    if (LeaveIdToDelete) {
      removeLeave(LeaveIdToDelete);
    }
    closeModal();
  };

  // remove
  const removeLeave = async (leaveId) => {
    const removeData = { Id: leaveId, TableName: "Leave" };

    try {
      const res = await deleteLeaves(removeData, UID);
      console.log("res", res);

      if (res && res.data) {
        if (res.data.message === "Deleted Successfully") {
          toast.success("Leave deleted successfully");
          fetchLeaves();
        } else {
          toast.error("Unexpected response from the server.");
        }
      } else {
        toast.error("Error deleting Category");
      }
      // Check for response and data
    } catch (error) {
      if (error.response && error.response.status === 409) {
        const errorMessage =
          error.response.data?.message ||
          "Conflict occurred while deleting Leave.";
        toast.error("Leave already using cannot delete");
      } else {
        console.error("Error removing Leave:", error);
        toast.error("Error deleting Leave. Please try again.");
      }
    }

  };
  //

  const currentYear = new Date().getFullYear();
  const futureYears = 5;
  const years = [];
  for (let year = currentYear; year <= currentYear + futureYears; year++) {
    years.push(year);
  }
  const columnsFilter = [
    {
      name: "Sl No",
      // Instead of selector, use cell
      cell: (row, index) => {
        // Access the current page and rows per page from the component props
        const firstRow = filteredItems.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
    },
    {
      name: "Leave Name",
      // selector: (row) => row.LeaveName,
      // sortable: true,
      selector: (row) => {
        const leaveName = typesofLeaves?.find((el) => el.Id === row.TypeId);
        return leaveName ? leaveName.Name : "N/A"; // Handle case where category is not found
      },
    },
    {
      name: "Year",
      selector: (row) => row.Year,
      sortable: true,
    },

    {
      name: "Category",
      selector: (row) => {
        const CategoryNam = category?.find((el) => el.Id === row.CategoryId);

        return CategoryNam ? CategoryNam.Name : "N/A"; // Handle case where category is not found
      },
    },
    {
      name: "No Of Leaves",
      selector: (row) => row.NoOfLeaves,
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div className="flex items-stretch gap-10">
          <button
            className="bg-sky rounded-[4px] px-10 py-[8px]"
            onClick={() => openEditLeaveModal(row)}
          >
            <IconEdit className="text-white w-[18px] h-[18px]" />
          </button>
          <button
            className="bg-danger rounded-[4px] px-10 py-[8px]"
            onClick={() => openModal(row.Id)}
          >
            <IconTrash className="text-white w-[18px] h-[18px]" />
          </button>
        </div>
      ),
    },
  ];

  // const formatTime = timestamp => new Date(timestamp).toISOString().slice(11, 16);

  const filteredItems = dataFilter.filter((item) => {
    const CategoryNam = category?.find((el) => el.Id === item.CategoryId)?.Name;

    return (
      String(item.Year).toLowerCase().includes(filterText?.toLowerCase()) ||
      item.LeaveName?.toLowerCase().includes(filterText?.toLowerCase()) ||
      item.Narration?.toLowerCase().includes(filterText?.toLowerCase()) ||
      CategoryNam?.toLowerCase().includes(filterText?.toLowerCase()) ||
      String(item.NoOfLeaves).toLowerCase().includes(filterText?.toLowerCase())
    );
  });

  const categoryOptions = category.map((dept) => ({
    value: dept.Id,
    label: dept.Name,
  }));

  const subHeaderComponentMemo = useMemo(() => {

  }, [filterText, resetPaginationToggle]);


  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults);  // Update state with the filtered data
  };

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };
  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };
  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 bg-bg-transparent backdrop-blur-sm flex justify-center items-start pt-5 z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-[500px] mx-4 md:mx-0 z-60 mt-10">
            <p className="text-center mb-4 text-lg font-semibold">
              Are you sure you want to delete this Leave?
            </p>
            <div className="flex justify-end">
              <button
                className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition-colors mr-5"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-colors"
                onClick={confirmDelete}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="flex items-center justify-between mb-8">
        <Breadcrumb title="Leaves" />
        {/* Action Area */}
        <div className="flex items-center gap-4">
          {/* Search and Clear Buttons */}
          <div className="flex items-center gap-2 p-5 bg-gray-100 rounded">
            <button
              className="bg-sky rounded-[4px] px-10 py-[8px]"
              onClick={handleFilterClick}
            >
              <IconFilter className="text-white w-[18px] h-[18px]" />
            </button>
            <div className="relative">
              <input
                type="text"
                id="search"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                placeholder="Search by Name/Year/Category"
                className="w-64 px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <button
              onClick={handleClear}
              className="btn btn-danger"
            >
              Clear
            </button>
          </div>

          {/* Add New Button */}
          <button
            onClick={openAddLeaveModal}
            className="btn btn-primary"
          >
            Add New
          </button>
        </div>
      </div>
      {isFilterVisible && (
        <FilterComponent columns={columnsFilter} data={leaves} onFilter={handleFilter} />
      )}

      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">
        <div className="react-data-table">
          <div className="react-data-table">
            {loading ? (
              <Loading />
            ) : (
              <ReactDataTable
                columns={columnsFilter}
                data={filteredItems}
                pagination
                paginationResetDefaultPage={resetPaginationToggle}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              />
            )}
          </div>
        </div>

      </div>
      {addLeaveModal && (
        <>
          <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
            <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
              <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                Add Leave
                <span className="absolute top-0 right-0">
                  <button
                    onClick={openAddLeaveModal}
                    className="btn flex items-center justify-center"
                  >
                    ✖
                  </button>
                </span>
              </h5>
              <form
                onSubmit={handleSubmit} // Attach your submit handler
                className="my-10 md:px-10 px-[7px] "
              >
                <div className="my-10 md:px-10 px-[7px]">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="form-group flex flex-col gap-2">
                      <label>
                        {" "}
                        Leave Type <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        name="TypeId"
                        value={leaveData.TypeId}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled>
                          Leave Type
                        </option>
                        {typesofLeaves.map((center) => (
                          <option key={center.Id} value={center.Id}>
                            {center.Name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {typesofLeaves.find(
                      (type) =>
                        type.Id === leaveData.TypeId &&
                        type.Name.toLowerCase() === "annual leave"
                    ) && (
                        <>
                          <div className="form-group flex flex-col gap-2">
                            <label>
                              No of Working days for extra leave{" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="number"
                              id="name"
                              name="NoOfWorkingdays"
                              placeholder="No of Working days for extra leave"
                              value={leaveData.NoOfWorkingdays}
                              onChange={handleChange}
                              required
                              onWheel={(e) => e.target.blur()}

                            />
                          </div>
                          <div className="form-group flex flex-col gap-2">
                            <label>
                              No of extra leave{" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="number"
                              id="name"
                              name="NoOfextraleave"
                              placeholder="No of  extra leave"
                              value={leaveData.NoOfextraleave}
                              onChange={handleChange}
                              required
                              onWheel={(e) => e.target.blur()}

                            />
                          </div>
                        </>
                      )}

                    <div className="form-group flex flex-col gap-2">
                      <label>
                        Select Year: <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        name="Year"
                        value={leaveData.Year}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Year</option>
                        {years.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group flex flex-col gap-2">
                      <label>
                        {" "}
                        No of Leave <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="leave"
                        name="NoOfLeaves"
                        placeholder="No of Leave"
                        value={leaveData.NoOfLeaves}
                        onChange={handleChange}
                        required
                        onWheel={(e) => e.target.blur()}

                      />
                    </div>

                    {/* <div className="form-group flex flex-col gap-2 p-5 ">
                      <label className="flex flex-row items-center  mt-[9%] gap-2">
                        <p>Halfday </p><span>check</span>
                      </label>

                        <input className="mt-[-9%]"
                          type="checkbox"
                          checked={isChecked}
                          onChange={handleCheckboxChange}
                          value={leaveData.isChecked}
                          
                        />
                    </div>
                    {isChecked && (
                      <div className="form-group flex flex-col gap-2">
                        <label>
                          Percentage <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="number"
                          id="percentage"
                          name="percentage"
                          placeholder="Enter percentage"
                          value={leaveData.percentage}
                          onChange={handleChange}
                          min="0"
                          max="100"
                          required
                          onWheel={(e) => e.target.blur()}

                        />
                      </div>
                    )} */}

                    <div className="form-group flex flex-col gap-2">
                      <label>
                        Category <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        isMulti
                        name="CategoryId"
                        // value={leaveData.CategoryId || []}
                        value={categoryOptions?.filter((option) =>
                          leaveData.CategoryId?.includes(option.value)
                        )}
                        onChange={(selectedOptions) =>
                          handleChange(selectedOptions)
                        }
                        options={categoryOptions}
                        required
                      />

                    </div>


                    <div className="form-group flex flex-col gap-2">
                      <label>
                        Maximum Allowable Leaves{" "}
                        <span style={{ color: "red" }}>*</span>{" "}
                      </label>
                      <input
                        type="number"
                        id="AllowableLeave"
                        name="AllowableLeave"
                        placeholder="Maximum Allowable Leaves "
                        value={leaveData.AllowableLeave}
                        onChange={handleChange}
                        required
                        onWheel={(e) => e.target.blur()}

                      />
                    </div>

                    <div className="form-group flex flex-col gap-2">
                      <label>
                        {" "}
                        Max Allowable Leaves(with approval){" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="SpecialLeave"
                        name="SpecialLeave"
                        placeholder="Max Allowable Leaves(with approval)"
                        value={leaveData.SpecialLeave}
                        onChange={handleChange}
                        required
                        onWheel={(e) => e.target.blur()}

                      />
                    </div>
                  </div>
                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearData}
                    className="btn btn-outline-secondary"
                    disabled={loading}
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Add"}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            // onClick={openAddLeaveModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}

      {/* ========================================================EDIT======================================================== */}

      {editLeaveModal && (
        <>
          <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
            <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
              <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                Edit Leave
                <span className="absolute top-0 right-0">
                  <button
                    onClick={openEditLeaveModal}
                    className="btn flex items-center justify-center"
                  >
                    ✖
                  </button>
                </span>
              </h5>

              <form
                onSubmit={handleEdit} // Attach your submit handler
                className="my-10 md:px-10 px-[7px] "
              >
                <div className="my-10 md:px-10 px-[7px]">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="form-group flex flex-col gap-2">
                      <label>
                        {" "}
                        Leave Type <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        name="TypeId"
                        value={leaveData.TypeId ||''}
                        onChange={handleChange}
                        required
                      >
                        {/* <option key="" value="">
                          {leaveData.LeaveName || "Select Leave Type"}
                        </option> */}
                         <option value="" disabled hidden>
      Select Leave Type
    </option>
                        {typesofLeaves.map((data) => (
                          <option key={data.Id} value={data.Id}>
                            {data.Name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {typesofLeaves.find(
                      (type) =>
                        type.Id === leaveData.TypeId &&
                        type.Name.toLowerCase() === "annual leave"
                    ) && (
                        <>
                          <div className="form-group flex flex-col gap-2">
                            <label>
                              No of Working days for extra leave{" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="number"
                              id="NoOfWorkingdays"
                              name="NoOfWorkingdays"
                              placeholder="No of Working days for extra leave"
                              value={leaveData.NoOfWorkingdays}
                              onChange={handleChange}
                              required
                              onWheel={(e) => e.target.blur()}

                            />
                          </div>
                          <div className="form-group flex flex-col gap-2">
                            <label>
                              No of extra leave{" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="number"
                              id="name"
                              name="NoOfextraleave"
                              placeholder="No of  extra leave"
                              value={leaveData.NoOfextraleave}
                              onChange={handleChange}
                              required NoOfextraleave
                              onWheel={(e) => e.target.blur()}

                            />
                          </div>
                        </>
                      )}

                    <div className="form-group flex flex-col gap-2">
                      <label>
                        Select Year: <span style={{ color: "red" }}>*</span>{" "}
                      </label>
                      <select
                        name="Year"
                        value={leaveData.Year||''}
                        onChange={handleChange}
                        required
                      >
                        {/* <option value="">{leaveData.Year}</option> */}
                        <option value="" disabled hidden>
      Select Year
    </option>
                        {years.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group flex flex-col gap-2">
                      <label>
                        {" "}
                        No of Leave <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="NoOfLeaves"
                        name="NoOfLeaves"
                        placeholder="NoOfLeaves"
                        value={leaveData.NoOfLeaves}
                        onChange={handleChange}
                        required
                        onWheel={(e) => e.target.blur()}

                      />
                    </div>

                    {/* <div className="form-group flex flex-col gap-2">
                      <label className="flex flex-row items-center mt-[13%] gap-2">
                      <p>Halfday </p><span>check</span>  
                      </label>
                        <input className="mt-[-9%]"
                          type="checkbox"
                          checked={isChecked}
                          onChange={handleCheckboxChange}
                          value={leaveData.isChecked}

                        />


                    </div>
                    {isChecked && (
                      <div className="form-group flex flex-col gap-2">
                        <label>
                          Percentage <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="number"
                          id="percentage"
                          name="percentage"
                          placeholder="Enter percentage"
                          value={leaveData.percentage}
                          onChange={handleChange}
                          min="0"
                          max="100"
                          required
                          onWheel={(e) => e.target.blur()}

                        />
                      </div>
                    )} */}

                    <div className="form-group flex flex-col gap-2">
                      <label>
                        Category <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        name="CategoryId"
                        value={leaveData.CategoryId}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled>
                          Select category
                        </option>
                        {category.map((center) => (
                          <option key={center.Id} value={center.Id}>
                            {center.Name}
                          </option>
                        ))}
                      </select>
                    </div>


                    <div className="form-group flex flex-col gap-2">
                      <label>
                        Maximum Allowable Leaves{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="AllowableLeave"
                        name="AllowableLeave"
                        placeholder="  Maximum Allowable Leaves"
                        value={leaveData.AllowableLeave}
                        onChange={handleChange}
                        required
                        onWheel={(e) => e.target.blur()}

                      />
                    </div>
                    <div className="form-group flex flex-col gap-2">
                      <label>
                        {" "}
                        Max Allowable Leaves(with approval){" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="SpecialLeave"
                        name="SpecialLeave"
                        placeholder="Max Allowable Leaves(with approval)"
                        value={leaveData.SpecialLeave}
                        onChange={handleChange}
                        required
                        onWheel={(e) => e.target.blur()}

                      />
                    </div>
                  </div>
                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearDataedit}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Edit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            // onClick={openEditLeaveModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}
    </>
  );
}
